import { getSelectionListTypes } from './getSelectionListTypes';

/**
 * Determines if the specified list type is included in the
 * current selection.
 *
 * @param {Object} listType  The list type to check.
 * @param {Object} state     The current editor state.
 *
 * @returns {boolean} Whether or not the list type is within the selection.
 *
 */
const isListActive = (listType, state) => {

	const { from, to } = state.selection;

	const listTypes = getSelectionListTypes(from, to, state);

	const containsListType = listTypes.find((type) => type === listType);

	return containsListType && listTypes.length === 1;

};

export default isListActive;
